export {default} from "./Tabs";
